import { ChangeRequestProgressInfo } from '@/types';

export const setBuyerChangeRequests = (data: ChangeRequestProgressInfo[]) => ({
    type: 'BUYER_SET_CHANGE_REQUESTS',
    data,
});
export const setBuyerChangeRequest = (data: ChangeRequestProgressInfo) => ({
    type: 'BUYER_SET_CHANGE_REQUEST',
    data,
});
